import { render } from "./LeadsListFailed.vue?vue&type=template&id=246aa292"
import script from "./LeadsListFailed.vue?vue&type=script&lang=js"
export * from "./LeadsListFailed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__